var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1199_5236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H20.6966V20.6689H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1199_5236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64251 1.5C2.73851 1.5 1.49951 2.976 1.49951 6.433V14.232C1.49951 17.416 3.25751 19.169 6.44951 19.169H14.2315C17.4155 19.169 19.1685 17.416 19.1685 14.232V14.229L19.1965 9.264C19.1965 5.865 18.0305 4.54 15.0355 4.54H12.2055C11.2565 4.539 10.3505 4.086 9.78051 3.328L8.86751 2.114C8.58051 1.729 8.12151 1.501 7.64151 1.5H5.64251ZM14.2315 20.669H6.44951C2.47151 20.669 -0.000488281 18.202 -0.000488281 14.232V6.433C-0.000488281 2.164 1.89851 0 5.64251 0H7.64251C8.59351 0.001 9.49951 0.455 10.0675 1.214L10.9785 2.426C11.2675 2.81 11.7265 3.039 12.2065 3.04H15.0355C18.8975 3.04 20.6965 5.019 20.6965 9.268L20.6685 14.235C20.6675 18.203 18.2015 20.669 14.2315 20.669Z",
    fill: "#878787"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.716 13.7129H5.98096C5.56696 13.7129 5.23096 13.3769 5.23096 12.9629C5.23096 12.5489 5.56696 12.2129 5.98096 12.2129H14.716C15.13 12.2129 15.466 12.5489 15.466 12.9629C15.466 13.3769 15.13 13.7129 14.716 13.7129Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentationIcon);
export default __webpack_public_path__ + "static/media/documentation-icon.ae435952ac6cbf2daeae38e1d3ac3751.svg";
export { ForwardRef as ReactComponent };